import React, { useContext, useEffect, useState } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";
import { Close, Warning } from "@mui/icons-material";

const DocumentWarningNotification = (props) => {

    const { data = {}, duplicateDocumentView, setDialogs } = useContext(DocumentDetailContext);

    return <div className="warning_msg" style={{background: props.bgColor, color: props.color}}>
        <div>
            {props.icon || null}
            <div className="msg-content">
                <div>{props.message}</div>
            </div>
        </div>
        {!duplicateDocumentView && props.showClose ? <Close onClick={() => {
            setDialogs(prev => ({
                ...prev,
                [props.type]: true
            }))
        }}/> : null}
    </div>
}

export default DocumentWarningNotification;